export default class CommentFlagController {
  static values = {
    url: String,
    flagged: Boolean
  }

  static targets = ['button']

  connect() {
    this.flagged = this.flaggedValue
  }

  async flag() {
    if (this.flagged) return

    try {
      const response = await fetch(this.urlValue, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-CSRF-Token': this.csrfToken()
        }
      })

      if (response.ok) {
        const data = await response.json()
        this.flagged = data.flagged
        this.buttonTarget.textContent = 'Denunciado'
        this.buttonTarget.classList.add('comment__action--active')
        this.buttonTarget.disabled = true
      }
    } catch (error) {
      console.error('Comment flag error:', error)
    }
  }

  csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.content : ''
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-controller="comment-flag"]').forEach(el => {
    const controller = new CommentFlagController()

    controller.element = el
    controller.urlValue = el.dataset.commentFlagUrlValue
    controller.flaggedValue = el.dataset.commentFlagFlaggedValue === 'true'
    controller.buttonTarget = el.querySelector('[data-comment-flag-target="button"]')

    controller.connect()

    el.querySelectorAll('[data-action*="comment-flag#flag"]').forEach(btn => {
      btn.addEventListener('click', () => controller.flag())
    })
  })
})
